// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const rappitVersion = 'v26061';
const rappitNoSqlVersion = '{{RAPPIT_NOSQL_VERSION}}';

export const environment = {
  production: false,
  rappitVersion,
  rappitNoSqlVersion,
  apihost: `${rappitVersion}/rest/v1`,
  endPoints: {
    blueprint: `${rappitVersion}/blueprint/api/v1`,
    companion: `${rappitVersion}/aicompanion`
  },
  testCaseManagement: 'https://rappit-validator-219188298501.europe-west1.run.app/test-case-management',
  cloudCenter: 'https://cloudops-center-224611761473.europe-west1.run.app/home/dashboard',
  agents: 'https://raf-agent-designer-24630091326.europe-west1.run.app/rd-home',
  learnUrl: 'https://rappit-developer.rappit.io/docs/',
  documentationUrl: 'https://success.rappit.io/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
